import AuthService from '../../AuthService';
const LandingPage = {
  getLandingPage(page){
    return AuthService.get(`landing_page?page=${page}`);
  },
  showLandingPage(id){
    return AuthService.get(`landing_page/${id}`);
  },
  createLandingPage(data){
    return AuthService.post(`landing_page`,data);

  },
  updateLandingPage(id,data){
    return AuthService.put(`landing_page/${id}`,data);

  },
  deleteLandingPage(id){
    return AuthService.delete(`landing_page/${id}`);

  },
}
export default LandingPage
